var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "page"
  }, [_c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('div', {
    staticClass: "pa-5 mb-6",
    staticStyle: {
      "border": "1px solid #ccc",
      "border-radius": "8px"
    }
  }, [_c('v-row', {
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "7"
    }
  }, [_c('div', {
    staticClass: "text-h5 font-weight-bold"
  }, [_vm._v(_vm._s(_vm.$user.fullName))]), _c('div', {
    staticClass: "text-body-2 text-grey-darken-1 mt-1"
  }, [_vm._v(" Função no Programa: " + _vm._s(_vm.$user.cargo) + " ")])]), _c('v-col', {
    staticClass: "text-right",
    attrs: {
      "cols": "4"
    }
  }, [_c('v-icon', {
    staticClass: "mr-1 text-grey-darken-1",
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-email")]), _c('span', {
    staticClass: "text-body-2"
  }, [_vm._v(_vm._s(_vm.$user.email))])], 1)], 1)], 1), _c('v-form', {
    ref: "form"
  }, [_c('v-row', {
    staticClass: "d-flex justify-center mt-3"
  }, [_c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Nome da Turma",
      "outlined": "",
      "dense": ""
    },
    on: {
      "keyup": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.buscarAcompanhamentoDeTurmas.apply(null, arguments);
      }
    },
    model: {
      value: _vm.form.filters.nome,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "nome", $$v);
      },
      expression: "form.filters.nome"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "label": "Ano/Série",
      "item-text": "nome",
      "item-value": "id",
      "outlined": "",
      "dense": "",
      "items": _vm.form.lists.listAnoSeries
    },
    model: {
      value: _vm.form.filters.anoSerieId,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "anoSerieId", $$v);
      },
      expression: "form.filters.anoSerieId"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "label": "Turno",
      "item-text": "descricao",
      "item-value": "id",
      "outlined": "",
      "dense": "",
      "items": _vm.form.lists.listTurnos
    },
    model: {
      value: _vm.form.filters.turnoId,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "turnoId", $$v);
      },
      expression: "form.filters.turnoId"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "label": "Escola",
      "item-text": "local",
      "item-value": "id",
      "outlined": "",
      "dense": "",
      "items": _vm.form.lists.listEscolas
    },
    model: {
      value: _vm.form.filters.escolaId,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "escolaId", $$v);
      },
      expression: "form.filters.escolaId"
    }
  })], 1)], 1), _c('div', {
    staticClass: "text-center"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('sca-tooltip', {
    attrs: {
      "text": 'Buscar',
      "icon": 'mdi-magnify'
    },
    on: {
      "click": function ($event) {
        return _vm.buscarAcompanhamentoDeTurmas();
      }
    }
  }), _c('sca-tooltip', {
    attrs: {
      "text": 'Limpar',
      "icon": 'mdi-eraser'
    },
    on: {
      "click": function ($event) {
        return _vm.resetForm();
      }
    }
  })], 1)], 1)], 1), _c('v-data-table', {
    staticClass: "mt-5",
    attrs: {
      "headers": _vm.headers,
      "items": _vm.form.lists.listAcompanhamentoDeTurmas,
      "items-per-page": 10,
      "footer-props": _vm.$footerProps,
      "no-data-text": "Não há registros a serem exibidos",
      "item-key": "id",
      "custom-sort": _vm.$customSort
    },
    scopedSlots: _vm._u([{
      key: `item.acoes`,
      fn: function (_ref) {
        var item = _ref.item;
        return [_c('sca-tooltip', {
          attrs: {
            "text": 'Visualizar',
            "icon": 'mdi-eye-outline',
            "small": true
          },
          on: {
            "click": function ($event) {
              return _vm.goToVisualizarAcompanhamento(item);
            }
          }
        }), _c('sca-tooltip', {
          attrs: {
            "text": 'Editar',
            "icon": 'mdi-pencil',
            "small": true
          },
          on: {
            "click": function ($event) {
              return _vm.goToEditarAcompanhamento(item);
            }
          }
        })];
      }
    }], null, true)
  })], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }